import { z } from 'zod/v4';

export const paginatedListResponseSchema = <T extends z.ZodType>(itemSchema: T) =>
    z.union([
        z.array(itemSchema).transform((data) => ({
            data,
            total: data.length,
            page: 1,
            pageSize: data.length,
            totalPages: data.length > 0 ? 1 : 0
        })),
        z.object({
            data: z.array(itemSchema),
            total: z.number().int().nonnegative(),
            page: z.number().int().min(1),
            pageSize: z.number().int().min(1),
            totalPages: z.number().int().nonnegative()
        })
    ]);

export type PaginatedListResponse<T> = {
    data: T[];
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
};

export type PaginationArgs = {
    page?: number;
    pageSize?: number;
};

export function buildPaginationSearchParams(
    args: PaginationArgs,
    options?: {
        pageParamName?: string;
        pageSizeParamNames?: string[];
    }
) {
    const searchParams = new URLSearchParams();
    const pageParamName = options?.pageParamName ?? 'page';
    const pageSizeParamNames = options?.pageSizeParamNames ?? ['pageSize'];

    if (args.page) {
        searchParams.set(pageParamName, String(args.page));
    }

    if (args.pageSize) {
        pageSizeParamNames.forEach((paramName) => {
            searchParams.set(paramName, String(args.pageSize));
        });
    }

    return searchParams;
}
